import { gameData, networkData,  demoState } from "../data"
import { banderitasCollection } from "../gameUI"
import { baseScore, pattern, pumpMultiplier } from "../networkService"
import { setPumpMultiplierInAnimation } from "../pump"

export function highlightWinFlags(){
    const dataScratchScore = networkData?.dataScratchScore
    const gameResult = dataScratchScore?.gameResult
    
    const patternValue = pattern() ?? networkData.allFlagValues
    let baseScoreValue = demoState.isDemo ? gameData.winNumber : baseScore() ?? networkData?.dataScratchScore?.baseScore
    baseScoreValue = +baseScoreValue

    // if (!patternValue || !baseScoreValue) return console.error(`(POPUP) Error: baseScoreValue: ${baseScoreValue}, mangoesValue: ${patternValue}`, patternValue)

    if(demoState.isDemo){
        if(baseScoreValue == 10000){
            baseScoreValue = '10K'
        } else if(baseScoreValue == 1000){
            baseScoreValue = '1K'
        }
       banderitasCollection.forEach((v, index)=>{
      if(v.under.multiplierValue.text == baseScoreValue){
        
        v.under.flagSpecialReveal()
      }
    })
   } else {
       patternValue.forEach((scoreValue, index) => {
           if(scoreValue == baseScoreValue) banderitasCollection[index].under.flagSpecialReveal()
       })
   }

}

export const pumpBurstMultiplierSet = () => {
    const pumpMultiplierValue = demoState.isDemo ? gameData.multiplierVal : pumpMultiplier() ?? networkData?.dataScratchScore?.multiplier

    if (pumpMultiplierValue === '1') setPumpMultiplierInAnimation(1)
    if (pumpMultiplierValue === '2') setPumpMultiplierInAnimation(2)
    if (pumpMultiplierValue === '3') setPumpMultiplierInAnimation(3)
    if (pumpMultiplierValue === '4') setPumpMultiplierInAnimation(4)

}